export default {
  CARD: 'card',
};
